const state = {
  isLoading: false,
  erpStatus: true,
};

export default state;
